<template>
  <div class="education-column-selected-article-list-component">
    <div class="education-column-selected-article-item"
         v-for="item in list"
         :key="item.id"
         @click="handleClickArticle(item)"
    >
      <div v-if="item.author"
           class="education-column-selected-article-author"
           @click.stop="handleClickAuthor(item)"
      >
        <ym-avatar class="education-column-selected-article-author-avatar"
                   :avatar="item.author.avatar"
                   size="small"
        />
        <div class="education-column-selected-article-author-info">
          <h4 class="education-column-selected-article-author-name ym-line-ellipsis">
            {{ item.author.name }}
          </h4>
          <div class="education-column-selected-article-author-title ym-line-ellipsis">
            {{ item.author.title }}
          </div>
        </div>
      </div>
      <div class="education-column-selected-article-content">
        <rect-cover class="education-column-selected-article-cover"
                    :src="item.rectCover"
                    :alt="item.title"
        />
        <h3 class="education-column-selected-article-title">
          {{ item.title }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
  import YmAvatar from '@/components/Avatar';
  import RectCover from '@/pages/EducationColumn/components/RectCover';
  import { locationHref } from '@/utils';

  export default {
    name: 'EducationColumnSelectedArticleList',
    components: {
      YmAvatar,
      RectCover,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
    methods: {
      handleClickArticle(item) {
        const { targetUrl } = item;
        if (targetUrl && targetUrl !== '') {
          locationHref(targetUrl);
        }
      },
      handleClickAuthor(item) {
        const { author } = item;
        const { id } = author;
        const route = { name: 'EducationColumnColumnistDetail', params: { id } };
        this.$router.push(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .education-column-selected-article {
    &-item {
      padding: @size-base @size-base @size-large;
      margin-bottom: @size-small;
      background-color: @color-white;
    }

    &-author {
      display: flex;
      overflow: hidden;
      margin-bottom: @size-base;
      line-height: 1;

      &-info {
        flex: 1;
        overflow: hidden;
      }

      &-avatar {
        margin-right: @size-small;
      }

      &-name {
        margin: 0 0 @size-extra-small;
        font-size: @font-size-medium;
      }

      &-title {
        font-size: @font-size-base;
        color: @color-text-light;
      }
    }

    &-content {
      border-radius: @education-column-border-radius;
      overflow: hidden;
      background-color: @background-color-lighter;
    }

    &-title {
      margin: @size-small @size-base @size-base;
      font-size: @font-size-large;
      line-height: 1.6;
    }
  }
</style>
